var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgConnect = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "235px",
    height: "175.464px",
    viewBox: "0 0 235 175.464",
    enableBackground: "new 0 0 235 175.464",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_CONNECT"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4_CONNECT",
    display: "none"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_CONNECT"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_CONNECT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M138,40.144v64.653         c0,9.655-7.286,18.203-16.939,18.203H60.19l-35.385,45.433L30.778,123H19.712C10.057,123,2,114.452,2,104.797V40.144         C2,30.49,10.057,23,19.712,23h101.349C130.714,23,138,30.49,138,40.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#396A92",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M97,19.175v64.653         C97,93.483,105.29,102,114.944,102h60.87l35.385,45.433L205.226,102h11.067C225.946,102,233,93.483,233,83.828V19.175         C233,9.521,225.946,2,216.293,2H114.944C105.29,2,97,9.521,97,19.175z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConnect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/connect.276b7d87.svg";
export { ForwardRef as ReactComponent };